import CompanyOverview from './CompanyOverview'
import CompanyDetails from './CompanyDetails'

const ROUTES = [
  CompanyOverview,
  CompanyDetails
]

export default ROUTES
